/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Country risk waiver subcategory of a service definition
 * @export
 */
export const WaiverType = {
    GlobalWaivers: 'GLOBAL_WAIVERS',
    MarketSpecificWaivers: 'MARKET_SPECIFIC_WAIVERS',
    MarketsWithSubaccounts: 'MARKETS_WITH_SUBACCOUNTS'
} as const;
export type WaiverType = typeof WaiverType[keyof typeof WaiverType];


export function instanceOfWaiverType(value: any): boolean {
    for (const key in WaiverType) {
        if (Object.prototype.hasOwnProperty.call(WaiverType, key)) {
            if (WaiverType[key as keyof typeof WaiverType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WaiverTypeFromJSON(json: any): WaiverType {
    return WaiverTypeFromJSONTyped(json, false);
}

export function WaiverTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WaiverType {
    return json as WaiverType;
}

export function WaiverTypeToJSON(value?: WaiverType | null): any {
    return value as any;
}

export function WaiverTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): WaiverType {
    return value as WaiverType;
}

